import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()({
    qrCodeContainer: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    },
    qrCodeImage: {
        width: 110,
        height: 110,
        objectFit: "contain",
        bgColor: "transparent",
    },
});
